import { Component, Input} from '@angular/core';

@Component({
    selector: 'app-ltms-loader',
    templateUrl: './ltms-loader.component.html',
    styleUrls: ['./ltms-loader.component.scss'],
    standalone: true
})
export class LtmsLoaderComponent {
  @Input() class:string='loader-default'
}
